<template>
  <div class="exhibitSwiperDitile">
    <!--    <audio class="audio" muted id="media" @ended="overAudio" src="https://sxbwygzh.oss-cn-beijing.aliyuncs.com/temp/40011638175784360.mp3" controls="controls"></audio>-->
    <audio id="audio" :src="datas.audio" @play="onPlay" @pause="onPause"></audio>
    <van-swipe class="my-swipe" indicator-color="white">
      <van-swipe-item v-for="(item,index) in listImg" :key="index">
        <video v-if="index == 0  && resultVideo" :src="resultVideo" controls></video>
        <img :src="item" alt="">
      </van-swipe-item>
    </van-swipe>
    <div class="ditile-box">
      <h4>{{ datas.name }}</h4>
      <!-- <div class="play-box">
        <img class="play" @click="muck" :src="require('../../../assets/' + (xz ? 'zts.png' : 'plays.png'))" alt="">
        <span>音频播放</span>
      </div> -->
      <div class="info-title">
        <p>地址：{{ datas.address }}</p>
        <p>时间：{{ datas.startDateTime }} ~ {{ datas.endDateTime }}</p>
      </div>
      <div class="info" :style="{height: moves ? 22 + 'vh' : 'auto'}" v-html="datas.description"></div>
      <div class="move" @click="moveClick">
        <img :class="moves ? '' : 'overMove'" src="../../../assets/move.png" alt="">
      </div>
    </div>
    <div class="Exhibits-title" v-if="datas.relicsList?.length !== 0">
      <span>展品</span>
    </div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in datas.relicsList" :key="index" @click="relicsListClick(item)">
          <img :src="item.images" alt="">
          <div class="names">
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'
import { getExhibitionQueryInfo } from '@/api/exhibit'

export default {
  name: 'exhibitSwiperDitile',
  data () {
    return {
      listImg: [],
      datas: '',
      moves: true,
      movesList: true,
      xz: false,
      moveIsopen: true,
      resultVideo: ''
    }
  },
  methods: {
    muck () {
      this.xz = !this.xz
      if (this.xz) {
        this.onPlay()
      } else {
        this.onPause()
      }
    },
    onPlay () {
      var videoPlayer = document.getElementById('audio')
      videoPlayer.play()
    },
    onPause () {
      var videoPlayer = document.getElementById('audio')
      videoPlayer.pause()
    },
    onEnded () {
      this.xz = false
      console.log('音频播放完毕')
    },
    unit (item) {
      console.log(item)
      this.$router.push(`/relicsRichText/${item.id}`)
    },
    relicsListClick (item) {
      console.log(item)
      this.$router.push(`/exhibitRichText/${item.id}`)
    },
    // miuke () {
    //   var audio = document.getElementById('media')
    //   console.log(this.datas.audio)
    //   if (audio.paused) { // 判断当前的状态是否为暂停，若是则点击播放，否则暂停
    //     this.xz = !this.xz
    //     audio.load()
    //     audio.play()
    //   } else {
    //     this.xz = !this.xz
    //     audio.pause()
    //   }
    // },
    overAudio () {
      this.xz = !this.xz
    },
    async listData () {
      const { result } = await getExhibitionQueryInfo(this.$route.params.id)
      console.log(result)
      this.datas = result
      if (this.datas.unitList.length <= 3) {
        this.movesList = false
        this.moveIsopen = false
      }
      if (result.video) {
        this.resultVideo = result.video
        // result.images.unshift(result.video)
      }
      this.listImg = result.images
    },
    moveClick () {
      this.moves = !this.moves
    },
    moveListClick () {
      this.movesList = !this.movesList
    },
    initSwiper () {
      this.swiper = new Swiper('.swiper-container', {
        loop: false,
        slidesPerView: 2, // 控制显示轮播图个数，（可以是小数：显示上一张末尾、下一张开头）
        spaceBetween: 5, // 图片之间间隙间隔
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false
        }
      })
    }
  },
  mounted () {
    this.listData()
    setTimeout(() => {
      this.initSwiper()
    }, 300)
    // this.listImg.unshift({
    //   img: 'https://yellow-river.oss-cn-beijing.aliyuncs.com/stable/kaiping2.mp4'
    // })
  }
}
</script>

<style lang="scss" scoped>
.exhibitSwiperDitile {
  min-height: 100vh;
  background-color: rgba(238, 238, 238, .4);
  font-family: 'PingFangMedium';
  .audio {
    display: none;
  }

  .my-swipe {
    border-radius: 0 0 15px 15px;
    overflow: hidden;
    margin-bottom: 30px;

    .van-swipe-item {
      height: 260px;

      video {
        width: 100%;
        height: 100%;
        background-color: #000;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .ditile-box {
    position: relative;
    width: 90%;
    padding: 0 20px;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px 0px rgba(153, 153, 153, 0.3);
    border-radius: 13px;
    //overflow: hidden;
    margin: 0 auto 20px;
    padding-bottom: 5px;
    .play-box {
      position: absolute;
      right: -18px;
      top: 70px;
      background: #FFFFFF;
      padding: 8px 11px;
      box-shadow: 0px 0px 10px 0px rgba(153, 153, 153, 0.3);
      border-radius: 25px 0px 0px 25px;
      .play {
        width: 30px;
        height: 30px;
        vertical-align: middle;
        margin-right: 10px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        vertical-align: middle;
      }
    }

    h4 {
      width: 100%;
      font-size: 20px;
      font-weight: bold;
      color: #330101;
      text-align: center;
      padding-top: 21px;
      padding-bottom: 18px;
      margin: 0;
      font-family: 'xique';
    }

    ul {
      overflow: hidden;

      li {
        padding: 18px 0;
        border-bottom: 1px solid rgba(230, 230, 230, 1);
        font-size: 14px;
        font-weight: bold;
        color: #333333;

        &:last-child {
          border-bottom: 0;
        }
      }
    }

    .info-title {
      p {
        font-size: 14px;
        font-weight: 400;
        color: #999999;

        &:nth-child(1) {
          margin-bottom: 10px;
        }
      }
    }

    .info {
      width: 100%;
      font-size: 12px;
      font-weight: 500;
      color: #333333;
      line-height: 1.5;
      margin-bottom: 13px;
      overflow: hidden;
      text-align: justify;
    }

    .move {
      width: 100%;
      height: 24px;
      text-align: center;
      margin-bottom: 10px;

      img {
        height: 100%;
        transition: .2s all;
      }
    }

    .overMove {
      transform: rotate(180deg)
    }
  }

  .Exhibits-title {
    width: 90%;
    margin: 0 auto 20px;

    span {
      &:nth-child(1) {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }

      &:nth-child(2) {
        float: right;
        font-size: 15px;
        font-weight: 500;
        color: #330101;
      }
    }
  }

  ::v-deep .swiper-container {
    width: 100%;
    height: 220px;
    padding-bottom: 20px;
  }

  .swiper-slide {
    width: 185px !important;
    text-align: center;
    font-size: 18px;
    background: #fff;
    display: inline-block;
    /* Center slide text vertically */
    //display: -webkit-box;
    //display: -ms-flexbox;
    //display: -webkit-flex;
    //display: flex;
    //-webkit-box-pack: center;
    //-ms-flex-pack: center;
    //-webkit-justify-content: center;
    //justify-content: center;
    //-webkit-box-align: center;
    //-ms-flex-align: center;
    //-webkit-align-items: center;
    //align-items: center;
    transition: 300ms;
    border-radius: 15px;
    overflow: hidden;

    img {
      width: 185px !important;
      height: 185px !important;
      object-fit: cover;
      display: block;
    }

    .names {
      width: 100%;
      text-align: center;
      padding: 10px 0;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      display: block;
      background-color: #fff;
    }
  }

  .swiper-slide:not(.swiper-slide-active) {
    transform: scale(0.8);
  }
}
</style>
